import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CountUp from 'react-countup';
import ServicesSlider from '../components/ServiceSlider';
import TestimonialCarousel from '../components/TestimonialCarousel';
import ButtonLink from '../components/ButtonLink';
import LogoSlider from '../components/LogoSlider';
import HeroSection from '../components/HeroSlide';
import 'bootstrap-icons/font/bootstrap-icons.css';
import MasonryGallery from "../components/MasonryGallery";

const imagesPage2 = [
   require("../assets/img/gallery/Image.jpg"),
      require("../assets/img/gallery/Image-1.jpg"),
      require("../assets/img/gallery/Image-2.jpg"),
      require("../assets/img/gallery/Image-3.jpg"),
      require("../assets/img/gallery/Image-4.jpg"),
      require("../assets/img/gallery/Image-5.jpg"),
];



function Home() {
    return (
        <div className="homepage">
        <section className="hero-section">
            <div className="hero-slider">
                <HeroSection /> 
            </div>
        </section>

        <section className="welcome-message section-padding">
        <Container>
          <Row className="align-items-center ">
            <Col lg={6} sm={12}>
            <div className="d-flex flex-column infor-di">
              
              <h2 className="title">Welcome to <span>V-Strong Contractor LLC</span></h2>
              <p>
              We are a construction and remodeling company with a solid reputation, built on quality and the trust of our clients. Every project we undertake reflects our commitment to precision, excellence, and attention to the details that make a difference. With a highly skilled team of professionals, we are dedicated to bringing your projects to life, whether residential or commercial.
              </p>
              <h4 className="subtitle">Our Missions :</h4>
              <div className="welcome-list">
                  <p>To provide our clients with an exceptional experience at every stage, from initial planning to final delivery. We are fully involved in each step to ensure that your ideas become reality, exceeding expectations and adding value to every space.</p>
              </div>
              <h4 className="subtitle">Our Vision :</h4>
              <div className="welcome-list">
                  <p>We aspire to be leaders in the construction industry, recognized for our innovation, professionalism, and commitment to customer satisfaction. Our goal is to leave a positive impact on every project, helping our clients create and enhance spaces that inspire and endure.</p>
              </div>
              </div>
            </Col>

            <Col lg={6} sm={12}>
              <div className="welcome-img">
                <img src={require('../assets/img/welcome-img.jpg')} alt="Welcome img" className='img-fluid' />
                <div className='content'>
                    <h4>
                    <CountUp end={160} duration={2.5} /> +
                    </h4>
                    <p>Satisfied Clients</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-padding">
        <Container>
            <Row>
                <Col>
                <div className="d-flex align-items-center justify-content-between py-3 title-box">
                  <h2 className="col-lg-8 title"><span>Discover The V-Strong 
                  Contractor LLC Specialized Services</span></h2>
                  <ButtonLink link="/service" name="Explore More" />
                </div>
                </Col>
            </Row>
        </Container>
        <Container fluid className="service-section pt-5 px-0">
            <Row>
                <Col md={12} className="px-0">
                  <ServicesSlider/>
                </Col>
            </Row>
        </Container>
      </section>

      <section className=" section-padding">
        <Container>
          <Row>
            <Col md={12} sm={12}>
              <div className="d-flex flex-column infor-di text-center">
              
              <h2 className="title">Why Choose Us</h2>
              <p className="col-lg-8 mx-auto mb-4">
              When you choose us, you choose experience, professionalism, and a full commitment to your projects. Our team is dedicated to offering personalized solutions that meet your specific needs, taking care of every detail to ensure flawless results. With us, you can trust that your project is in expert hands that value your time, investment, and ideas.
              </p>
              <Row>
                <Col sm={6} md={4} lg={4} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-headset"></i></span>
                  <h4 className="subtitle">Initial Consultation</h4>
                  <p>We meet with you to understand your needs, ideas, and budget.</p>
                  </div>
                </Col>

                <Col sm={6} md={4} lg={4} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-clipboard-check"></i></span>
                  <h4 className="subtitle">Customized Proposal</h4>
                  <p>We design a detailed plan that covers all aspects of the project, from materials to timeline.</p>
                  </div>
                </Col>

                <Col sm={6} md={4} lg={4} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-person-bounding-box"></i></span>
                  <h4 className="subtitle">Professional Execution</h4>
                  <p>Our team carries out the project following the highest standards of safety and quality.</p>
                  </div>
                </Col>

                <Col sm={6} md={4} lg={4} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-eyeglasses"></i></span>
                  <h4 className="subtitle">Final Review</h4>
                  <p>Once completed, we conduct a thorough inspection to ensure the result meets your expectations.</p>
                  </div>
                </Col>

                <Col sm={6} md={4} lg={4} className="mb-4">
                  <div className="icon-box">
                  <span><i class="bi bi-hand-thumbs-up"></i></span>
                  <h4 className="subtitle">Post-Completion Support</h4>
                  <p>We make sure you are fully satisfied and offer ongoing support if adjust -ments or maintenance are needed.</p>
                  </div>
                </Col>

                
              </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-padding gray-bg">
        <Container>
            <Row>
                <Col>
                <div className="d-flex align-items-center justify-content-between py-3 title-box">
                  <h2 className="col-lg-7 title">Recent Projects</h2>
                  <ButtonLink link="/gallery" name="Explore More" />
                </div>
                <MasonryGallery images={imagesPage2}/>
                </Col>
            </Row>
        </Container>
     </section>


      <section className="testimonial-wrapper section-padding">
        <Container>
            <Row>
                <Col lg={12} sm={12}>
                <div className="text-center">
                  <h2 className="title mb-4">Happy Customers, Happy World</h2>
                  <p className="col-lg-8 mx-auto mb-4">
                  Ready to transform your space? Contact us to experience the quality that our happy customers are raving about!
              </p>
                </div>
                </Col>
                <Col lg={12} sm={12}>
                <TestimonialCarousel />
                </Col>
            </Row>
        </Container>
     </section>

     <section className="logo-slider">
        <Container>
            <Row>
                <Col lg={12} sm={12}>
                  <LogoSlider />
                </Col>
            </Row>
        </Container>
     </section>


      <section className="section-padding">
        <Container>
            <Row>
                <Col>
                <div className="d-flex align-items-center justify-content-between py-3 title-box">
                  <h2 className="col-lg-7 title"><span>Let us be part of your projects. 
                  Your vision is our mission.</span></h2>
                  <ButtonLink link="/contact" name="Explore More" />
                </div>
                    
                </Col>
            </Row>
        </Container>
     </section>
     </div>
    );
}

export default Home;
